import React, { useState, useEffect } from 'react'

import { Button, Typography } from '@material-ui/core'

import { AddOutlined } from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles'

import { CustomAddOnOccurence } from '../Addons/customAddonOccurence'

import { useSelector } from 'react-redux'
import { v4 as uuid } from 'uuid'

const useStyles = makeStyles((theme) => ({
	customOccurences: {
		width: '100%'
	}
}))

export const CustomAddOnOccurences = (props) => {
	const classes = useStyles()
	let { customDates, setCustomDates, timeBlocks } = props
	const visit = useSelector((state) => state.specific.visits.selected)

	const [customAddonDates, setCustomAddonDates] = useState(customDates)

	useEffect(() => {
		setCustomAddonDates(customDates)
	}, [customDates])

	const updateCustomDate = (customDate) => {
		let customDateIndex = customDates.indexOf(customDate)

		if (customDateIndex > -1) {
			customDates[customDateIndex] = customDate

			setCustomDates(customDates)
		}
	}

	const deleteCustomDate = (customDate) => {
		let customDatesToUpdate = [...customDates]
		let customDateIndex = customDatesToUpdate.indexOf(customDate)

		if (customDateIndex > -1) {
			customDatesToUpdate.splice(customDateIndex, 1)

			setCustomDates(customDatesToUpdate)
		}
	}

	return (
		<div
			className={classes.customOccurences}
			style={{ flexDirection: customDates.length > 0 ? 'initial' : 'column' }}>
			{customAddonDates && customAddonDates.length > 0 ? (
				customDates.map((customDate) => (
					<CustomAddOnOccurence
						key={uuid()}
						customDate={customDate}
						updateCustomDate={updateCustomDate}
						deleteCustomDate={deleteCustomDate}
						timeBlocks={timeBlocks}
					/>
				))
			) : (
				<Typography style={{ marginBottom: '10px' }}>No custom dates created.</Typography>
			)}
			<Button
				variant="outlined"
				style={{ color: '#4D4C4F', borderColor: '#D0CFD2', marginBottom: '24px' }}
				startIcon={<AddOutlined style={{ fill: '#4D4C4F' }} />}
				onClick={() =>
					setCustomDates([
						...customDates,
						{
							date: null,
							time: visit && visit.type === 'daycare' ? 'midday' : null,
							dateError: false,
							timeBlockError: false
						}
					])
				}
				color="secondary">
				Add A Date
			</Button>
		</div>
	)
}
